<script lang="ts">
	import type { StatisticsData } from '@Shelly/shelly-design-system/LayerChart';

	//Helpers
	import { buildLayerChartSummarySections } from 'src/helpers/statistics/core/layer_chart_summary_helpers';

	export let statisticsData: StatisticsData;

	$: sections = buildLayerChartSummarySections(statisticsData);
</script>

{#if sections.length}
	<section class="layer-chart-content mb-s">
		{#each sections as section}
			<h3 class="layer-chart-content-title">{section.summaryTitle}</h3>
			<div class="layer-chart-content-box">{section.summary}</div>

			<h3 class="layer-chart-content-title">{section.aboutTitle}</h3>
			<div class="layer-chart-content-box">{section.about}</div>
		{/each}
	</section>
{/if}
